module.exports = __webpack_public_path__ + "img/no_data.7811a338.png";